export default {
  twoFactor: {
    // TwoFactorCard
    title: "Verificación en dos pasos (2FA)",
    loading: "Cargando…",
    error: "Error",
    enabledBadge: "✓ Activada.",
    enabledDesc: "Tu cuenta pide un código de tu app de autenticación al iniciar sesión.",
    orgRequires: " Tu organización exige 2FA, por eso no se puede desactivar.",
    disable: "Desactivar 2FA",
    currentPwdPlaceholder: "Tu contraseña actual",
    cancel: "Cancelar",
    confirmDisable: "Confirmar desactivación",
    disabledDesc: "Añade una capa extra de seguridad: además de tu contraseña, pedirá un código temporal de tu móvil al iniciar sesión.",
    enable: "Activar 2FA",
    // TwoFactorSetup
    setupError: "No se pudo iniciar la configuración",
    wrongCode: "Código incorrecto",
    preparing: "Preparando…",
    activatedTitle: "✅ 2FA activado",
    backupPre: "Guarda estos ",
    backupTerm: "códigos de respaldo",
    backupPost: " en un lugar seguro. Cada uno sirve una sola vez si pierdes el acceso a tu app de autenticación. No se volverán a mostrar.",
    backupSaved: "He guardado mis códigos — continuar",
    scanInstructions: "Escanea este QR con Google Authenticator, Authy o 1Password, y escribe el código de 6 dígitos.",
    qrAlt: "QR 2FA",
    manualKeyPrompt: "¿No puedes escanear? Clave manual:",
    codePlaceholder: "Código de 6 dígitos",
    verifying: "Verificando…",
  },
};
